import { render, staticRenderFns } from "./routtle.vue?vue&type=template&id=fd665ada&"
import script from "./routtle.vue?vue&type=script&lang=js&"
export * from "./routtle.vue?vue&type=script&lang=js&"
import style0 from "./routtle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports